import { Route, Switch, useRouteMatch } from "react-router-dom";

import { StripeOnboardingPage } from "./Page";

export function StripeOnboardingRouter() {
  const match = useRouteMatch();

  return (
    <Switch>
      <Route exact path={match.url}>
        <StripeOnboardingPage />
      </Route>
    </Switch>
  );
}
